import { createSelector } from 'reselect';
import getModuleState from './moduleStateSelector';

const getIsClearVisible = createSelector(
  getModuleState,
  (state) => state.get('isClearVisible')
);

export default getIsClearVisible;
